var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"softwaretree"},[_c('div',{staticClass:"tree-box"},_vm._l((_vm.list),function(el,index){return _c('div',{key:index,class:[index==_vm.treeIndex?'after':'','tree-list'],on:{"click":function($event){return _vm.treeBut(el,index)}}},[_vm._v(_vm._s(el.name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }